import { Card, CardContent } from '@/components/ui/card'
import PaymentEnterpriseInformation from './enterprise-infomation/enterprise-information'
import PaymentMethod from './payment-method/payment-method'
import { Separator } from '@/components/ui/separator'
import BillingContacts from './billing-contacts/billing-contacts'
import PaymentCurrentPlan from './current-plan/current-plan'
import { useUser } from '../../user-provider'

export default function PaymentCardBody() {
  const { paymentCurrentPlan } = useUser()
  return (
    <Card className="text-charcoal mt-4">
      <CardContent className="flex flex-col gap-8 py-8 w-full">
        <PaymentEnterpriseInformation />
        <Separator />
        <BillingContacts />
        {paymentCurrentPlan && <Separator />}
        <PaymentCurrentPlan />
        <Separator />
        <PaymentMethod />
      </CardContent>
    </Card>
  )
}
